import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
// import Timer from "./../store_audio/timer";
// import ScreenModifier from "./../store_audio/screen_modifier";
// import TextModifier from "./../store_audio/text_modifier";

export default class extends BridgeComponent {
  static component = "record";
  static values = {
    isShortTimer: Boolean,
  };
  static targets = [
    "start",
    "play",
    "pause",
    "stop",
    "visualizer",
    "timer",
    "title",
    "subtitle",
    "form",
    "audioInput",
  ];

  connect() {
    this.screenModifier = new ScreenModifier({
      startButton: this.startTarget,
      stopButton: this.stopTarget,
    });
    this.timer = new Timer({
      timer: this.timerTarget,
      isShortTimer: this.isShortTimerValue,
    });
    this.textModifier = new TextModifier({
      title: this.titleTarget,
      subtitle: this.subtitleTarget,
    });
  }

  start() {
    this.send("start", {}, (replyData) => {
      if (replyData && replyData.data.success) {
        this.timer.start();
        this.textModifier.recording();
        this.screenModifier.displayAudioControllers(
          [this.pauseTarget, this.stopTarget, this.visualizerTarget.parentNode],
          { disabledButton: this.pauseTarget },
        );
      }
    });
  }

  pause() {
    this.send("pause");
    this.textModifier.paused();
    this.screenModifier.toggleRecording({
      currentButton: this.pauseTarget,
      inactiveButton: this.playTarget,
      disableState: false,
    });
    this.timer.stop();
  }

  play() {
    this.textModifier.recording();
    this.screenModifier.toggleRecording({
      currentButton: this.playTarget,
      inactiveButton: this.pauseTarget,
      disableState: true,
    });
    this.timer.start();
    this.send("play");
  }

  stop() {
    const storageUrl = this.audioInputTarget.dataset.directUploadUrl;
    this.send("stop", { storageUrl }, (replyData) => { });
  }
}
